import { render, staticRenderFns } from "./Reporting.vue?vue&type=template&id=0326309c&scoped=true"
import script from "./Reporting.vue?vue&type=script&lang=js"
export * from "./Reporting.vue?vue&type=script&lang=js"
import style0 from "./Reporting.vue?vue&type=style&index=0&id=0326309c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0326309c",
  null
  
)

export default component.exports